export enum ProductApi {
  getProduct = '/product/:productId',
  searchProducts = '/product/search',
  getProductLastSoldDetails = '/order-items/history',
  realtimeInventory = '/inventory/realtime/:productId',
  getPromotions = '/promotion/search',
  getConfigurations = '/product/configuration'
}
